import React from "react";
import "./EliteSpinner.scss";
import { EliteSpinnerProps } from "../types";

class EliteSpinner extends React.Component<EliteSpinnerProps> {
    render(): React.ReactElement {
        return (
            <div className='loader loader3'>
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EliteSpinner;
